import { Counter, TABLE_VARIANT } from '../../../../../Counter'
import { EntityStatus } from '../../../../../Entity'
import { APPLICANT_STAGES } from '../../../../../RentalPortalApplicant'
import { Skeleton } from '../../../../../Skeleton'
import Text from '../../../../../Text'

import { getHasApplicantsBoardColumnTotal } from './RentalPortalApplicantsBoardColumnHeader.utils'

import * as styles from './RentalPortalApplicantsBoardColumnHeader.module.css'

function RentalPortalApplicantsBoardColumnHeader({ isLoading, stage, total }) {
  return (
    <div className={styles.RentalPortalApplicantsBoardColumnHeader}>
      <EntityStatus id={stage} statuses={APPLICANT_STAGES} />
      {isLoading ? (
        <Skeleton className={styles.skeletonCount} />
      ) : getHasApplicantsBoardColumnTotal(total) ? (
        <Counter count={total} variant={TABLE_VARIANT} />
      ) : (
        <Text className={styles.zeroCount}>{total}</Text>
      )}
    </div>
  )
}

export default RentalPortalApplicantsBoardColumnHeader
